import { FC, useMemo } from "react"
import { useAppSelector } from "../../app/hooks"
import { selectOrdersStore } from "../../app/reducers/ordersReducer"
import { MARKETPLACE } from "@acc/shared"
import { Select, type SelectOption } from "../Select/Select"

export type StorageSelectControlProps = {
  label?: string
  value: string
  onChange: (value: string) => void
  controlKey: string
  marketplace: MARKETPLACE
}

export const StorageSelectControl: FC<StorageSelectControlProps> = ({
  label,
  value,
  onChange,
  controlKey,
  marketplace,
}) => {
  const storageData = useAppSelector(selectOrdersStore)

  const storages = useMemo(() => {
    switch (marketplace) {
      case MARKETPLACE.WB:
        return storageData.storages.map((storage) => ({
          name: storage.name,
          id: storage.id,
          isHidden: !!storage.isHidden,
        }))
      case MARKETPLACE.YANDEX:
        return storageData.yandexCampaigns.map((storage) => ({
          name: storage.domain,
          id: storage.id,
          isHidden: !!storage.isHidden,
        }))
      case MARKETPLACE.OZON:
        return storageData.ozonStorages.map((storage) => ({
          name: storage.name,
          id: storage.warehouse_id,
          isHidden: !!storage.isHidden,
        }))
      default:
        return []
    }
  }, [marketplace, storageData])

  const options: SelectOption[] = useMemo(
    () =>
      storages
        .filter((el) => !el.isHidden)
        .map((storage) => ({
          value: String(storage.id),
          label: storage.name,
        })),
    [storages],
  )

  return (
    <Select
      label={label}
      value={value}
      onChange={onChange}
      options={options}
      rootKey={controlKey}
      placeholder="Выбрать склад"
      contentStyle={{ zIndex: 51 }}
    />
  )
}
